import React from 'react';
import { useNavigate } from 'react-router';
import { MdArrowBack } from 'react-icons/md';

export interface BackButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ 
  text, 
  onClick, 
  className = "" 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center transition-colors mb-4 ${className}`}
      style={{ color: '#EF4444' }}
      onMouseEnter={(e) => e.currentTarget.style.color = '#DC2626'}
      onMouseLeave={(e) => e.currentTarget.style.color = '#EF4444'}
    >
      <MdArrowBack className="h-4 w-4 mr-2" /> {text}
    </button>
  );
};

export default BackButton;
